import { render } from "./HeroiconsSolidReceiptRefund.vue?vue&type=template&id=03aa2e3c"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidReceiptRefund.vue"]])

export default __exports__